import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionLaboratoryApi = {
    getInstitutionLaboratories: (): Observable<Dtos.GetInstitutionLaboratoriesResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionLaboratories = new Dtos.GetInstitutionLaboratories();

        //Send request.
        const response: Promise<Dtos.GetInstitutionLaboratoriesResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionLaboratoryById: (id: number): Observable<Dtos.GetInstitutionLaboratoryByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionLaboratoryById = new Dtos.GetInstitutionLaboratoryById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionLaboratoryByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionLaboratoryByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetInstitutionLaboratoryByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionLaboratoryByLaboratoryId = new Dtos.GetInstitutionLaboratoryByLaboratoryId();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionLaboratoryByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionLaboratoryByInstitutionId: (institutionId: number): Observable<Dtos.GetInstitutionLaboratoryByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionLaboratoryByInstitutionId = new Dtos.GetInstitutionLaboratoryByInstitutionId();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionLaboratoryByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionLaboratory: (institutionLaboratory: Dtos.InstitutionLaboratory): Observable<Dtos.SetInstitutionLaboratoryResponse> => {

        let request: Dtos.SetInstitutionLaboratory = new Dtos.SetInstitutionLaboratory();

        request.institutionLaboratory = institutionLaboratory;

        // send request
        const response: Promise<Dtos.SetInstitutionLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    },
    createInstitutionLaboratory: (laboratoryId: number | null, institutionId: number | null): Observable<Dtos.CreateInstitutionLaboratoryResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionLaboratory = new Dtos.CreateInstitutionLaboratory();

        request.laboratoryId = laboratoryId;
        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionLaboratoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    deleteInstitutionLaboratory: (id: number): Observable<Dtos.DeleteInstitutionLaboratoryResponse> => {
        //Create the request.
        let request: Dtos.DeleteInstitutionLaboratory = new Dtos.DeleteInstitutionLaboratory();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteInstitutionLaboratoryResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionLaboratory: (institutionLaboratory: Dtos.InstitutionLaboratory): Observable<Dtos.ValidateInstitutionLaboratoryResponse> => {

        let request: Dtos.ValidateInstitutionLaboratory = new Dtos.ValidateInstitutionLaboratory();

        request.institutionLaboratory = institutionLaboratory;

        // send request
        const response: Promise<Dtos.ValidateInstitutionLaboratoryResponse> = client.post(request);

        return Observable.from(response);

    }
}